/** Shared visual contracts for Martina's operational surfaces. */
export const MARTINA_OPERATIONAL_CARD_CLASS =
  'martina-board-card flex h-[24rem] min-h-[24rem] max-h-[24rem] flex-col overflow-hidden rounded-lg border border-border bg-background p-[10px] shadow-sm transition-shadow hover:shadow-md';

// Icone piccole, target reali di 44px senza sovrapposizioni. La riga rating
// va a capo quando necessario invece di comprimere o tagliare i bersagli touch.
export const MARTINA_RATING_BUTTON_CLASS = 'h-11 w-11 min-w-11 shrink-0 p-0';
